import classNames from 'classnames';
import { useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PageContext from '@/Providers/PageContextProvider/PageContext';
import LogtoSignature from '@/shared/components/LogtoSignature';
import Preferences, { Brand } from '@/shared/platform/Preferences';
import { usePlatformCopy } from '@/shared/platform/copy';
import { changeLanguage } from '@/i18n/utils';
import { layoutClassNames } from '@/utils/consts';
import styles from './index.module.scss';
export default function AppLayout() {
  const { experienceSettings, theme } = useContext(PageContext);
  const copy = usePlatformCopy();
  const { pathname } = useLocation();
  const isSignIn = pathname === '/sign-in';
  return (
    <div
      className={classNames(
        styles.viewBox,
        'platform-experience',
        isSignIn && 'platform-auth-landing',
      )}
    >
      <header className="platform-topbar">
        <Brand />
        <Preferences changeLanguage={changeLanguage} />
      </header>
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        <main className={classNames(styles.main, layoutClassNames.mainContent)}>
          <Outlet />
          {experienceSettings?.hideLogtoBranding !== true && (
            <LogtoSignature
              className={classNames(styles.signature, layoutClassNames.signature)}
              theme={theme}
            />
          )}
        </main>
      </div>
      <footer className="platform-experience-footer">
        <span>{copy.footer}</span>
        <nav aria-label="Legal">
          <a href="/privacy/">Privacy</a>
          <a href="/terms/">Terms</a>
          <a href="/account-deletion/">Data deletion</a>
        </nav>
      </footer>
    </div>
  );
}
